import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ISparkHelpDocumentation } from '@domains/frontend/templates/spark';

import { FLYING_DOCUMENTATION_BASE_URL, FLYING_DOCUMENTATION_ROUTES } from './documentation-routes.data';


@Injectable({ providedIn: 'root' })
export class FlyingDocumentationService implements ISparkHelpDocumentation {
	constructor(
		private router: Router,
		@Inject(DOCUMENT) private document: Document
	) {}

	getUrl(route: string = this.router.url): string {
		const routePath: string = route.split(/[?#]/)[0].replace(/;[^/]*/g, '').replace(/\/+$/, '') || '/';
		const matchedRoute: string | undefined = Object.keys(FLYING_DOCUMENTATION_ROUTES)
			.sort((left: string, right: string) => right.length - left.length)
			.find((candidate: string) => routePath === candidate || routePath.startsWith(`${candidate}/`));
		const chapter: string = matchedRoute ? FLYING_DOCUMENTATION_ROUTES[matchedRoute] : 'help';
		return `${FLYING_DOCUMENTATION_BASE_URL}#${chapter}`;
	}

	openLink(event: MouseEvent, url: string): void {
		// Preserve native modified clicks, including opening a background tab.
		if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

		// Open synchronously while the user gesture is active. Detach the opener
		// before navigating, while retaining the handle needed to request focus.
		const documentationTab: Window | null | undefined = this.document.defaultView?.open('about:blank', '_blank');
		if (!documentationTab) return; // Leave the anchor's native navigation available.
		documentationTab.opener = null;
		documentationTab.location.replace(url);
		documentationTab.focus();
		event.preventDefault();
	}
}
